var chunkMapping = {
	"app": [
		"webpack/container/remote/@tarojs/plugin-platform-weapp/dist/runtime",
		"webpack/container/remote/@tarojs/plugin-framework-react/dist/runtime",
		"webpack/container/remote/react-dom"
	],
	"pages/virtual-list-demo/index": [
		"webpack/container/remote/prop-types",
		"webpack/container/remote/react/jsx-runtime"
	],
	"common": [
		"webpack/container/remote/@tarojs/runtime",
		"webpack/container/remote/@tarojs/taro",
		"webpack/container/remote/react"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/@tarojs/plugin-platform-weapp/dist/runtime": [
		"default",
		"./@tarojs/plugin-platform-weapp/dist/runtime",
		null
	],
	"webpack/container/remote/@tarojs/plugin-framework-react/dist/runtime": [
		"default",
		"./@tarojs/plugin-framework-react/dist/runtime",
		null
	],
	"webpack/container/remote/react-dom": [
		"default",
		"./react-dom",
		null
	],
	"webpack/container/remote/prop-types": [
		"default",
		"./prop-types",
		null
	],
	"webpack/container/remote/react/jsx-runtime": [
		"default",
		"./react/jsx-runtime",
		null
	],
	"webpack/container/remote/@tarojs/runtime": [
		"default",
		"./@tarojs/runtime",
		null
	],
	"webpack/container/remote/@tarojs/taro": [
		"default",
		"./@tarojs/taro",
		null
	],
	"webpack/container/remote/react": [
		"default",
		"./react",
		null
	]
};
__webpack_require__.taro = function(get) {
	for (var id in idToExternalAndNameMapping) {
		var mappedName = idToExternalAndNameMapping[id][1];
		var factory = get(mappedName);
		__webpack_modules__[id] = (function(factory) {
			return function(module) {
				module.exports = factory();
			}
		})(factory);
	}
};